import { TranslateService } from '@ngx-translate/core';
import { cloneDeep } from 'lodash';

export function translateArrayProperty<T>(
  items: T[],
  property: string,
  translateService: TranslateService,
): T[] {
  const toReturn: T[] = cloneDeep(items);
  (toReturn || []).forEach((entry: any) => {
    entry[property] = translateService.instant(entry[property]);
  });
  return toReturn;
}
